<template>
  <div
    ref="wrapper"
    class="dateTimePickerWrapper"
  >
    <input-group>
      <template slot="append">
        <span
          aria-hidden="true"
          class="input-group-text text-muted btn-pill"
          @click="openHandler"
        >
          <font-awesome-icon icon="calendar-alt" />
        </span>
      </template>
      <form-input
        v-model="innerDates"
        :name="inputName"
        readonly
      />
    </input-group>
    <date-picker-modal
      v-if="isOpen"
      :single-date="singleDate"
      :start-date="startDate"
      :end-date="endDate"
      @submit="__onSubmit"
      @cancel="__onCancel"
    />
  </div>
</template>
<script>
import moment from 'moment'
import '@lazy-copilot/datetimepicker/dist/datetimepicker.css'
import DatePickerModal from './DatePickerModal'
import FormInput from '~components/common/form/input'
import InputGroup from '~components/common/form/input/Group'

export default {
  name: 'DatePicker',
  components: {
    DatePickerModal,
    FormInput,
    InputGroup
  },
  props: {
    startDate: {
      type: [Date, String],
      default: () => moment().toDate()
    },
    endDate: {
      type: [Date, String],
      default: () => moment().toDate()
    },
    singleDate: {
      type: Boolean,
      default: true
    },
    inputName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isOpen: false,
      innerStartDate: this.startDate,
      innerEndDate: this.endDate
    }
  },
  computed: {
    innerDates () {
      return this.singleDate
        ? this.innerStartDate ? this.$moment(this.innerStartDate).format('YYYY/MM/DD') : ''
        : this.innerStartDate && this.innerEndDate ? this.$moment(this.innerStartDate).format('YYYY/MM/DD') + '~' + this.$moment(this.innerEndDate).format('YYYY/MM/DD') : ''
    }
  },
  watch: {
    startDate (value) {
      this.innerStartDate = this.$moment(value).toDate()
    }
  },
  methods: {
    openHandler () {
      this.isOpen = !this.isOpen
    },
    __onSubmit (data) {
      this.isOpen = false
      this.$emit('submit', data)

      return this.singleDate
        ? this._submitSingleHandler(data)
        : this._submitMultiHandler(data)
    },
    __onCancel () {
      this.isOpen = false
    },
    _submitSingleHandler (data) {
      this.innerStartDate = data.startDate
    },
    _submitMultiHandler (data) {
      this.innerStartDate = data.startDate
      this.innerEndDate = data.endDate
    }
  }
}
</script>
<style lang="scss">
.dateTimePickerWrapper {
  position: relative;
  //modal
  .dateTimeWrapper {
    left: 0;
    position: absolute;
    z-index: 198;
  }
  // .form-control[readonly]{
  //   background-color: #fff;
  // }
}
</style>
